import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [workspaces, setWorkspaces] = useState([]);
  const [workspaceId, setWorkspaceId] = useState(() => localStorage.getItem("fb_workspace_id") || null);
  const [ready, setReady] = useState(false);

  const persist = (token, u, ws) => {
    if (token) localStorage.setItem("fb_token", token);
    setUser(u);
    setWorkspaces(ws || []);
    if ((ws || []).length && !localStorage.getItem("fb_workspace_id")) {
      localStorage.setItem("fb_workspace_id", ws[0].id);
      setWorkspaceId(ws[0].id);
    }
  };

  const establishSession = (data) => persist(data.token, data.user, data.workspaces);

  const refreshMe = useCallback(async () => {
    try {
      const data = await api.me();
      localStorage.setItem("fb_token", data.token);
      setUser(data.user);
      setWorkspaces(data.workspaces);
      // Ensure workspaceId is valid
      const currentWs = localStorage.getItem("fb_workspace_id");
      const stillValid = data.workspaces.some((w) => w.id === currentWs);
      if (!stillValid && data.workspaces.length) {
        localStorage.setItem("fb_workspace_id", data.workspaces[0].id);
        setWorkspaceId(data.workspaces[0].id);
      }
    } catch (e) {
      // token invalid — cleared by interceptor
      setUser(null);
      setWorkspaces([]);
    }
  }, []);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("fb_token");
      if (token) await refreshMe();
      setReady(true);
    })();
  }, [refreshMe]);

  const signIn = async ({ email, password }) => {
    const data = await api.signin({ email, password });
    persist(data.token, data.user, data.workspaces);
    return data;
  };

  const signUp = async ({ email, password, name, workspace }) => {
    const data = await api.signup({ email, password, name, workspace });
    persist(data.token, data.user, data.workspaces);
    return data;
  };

  const signOut = () => {
    localStorage.removeItem("fb_token");
    localStorage.removeItem("fb_workspace_id");
    setUser(null);
    setWorkspaces([]);
    setWorkspaceId(null);
  };

  const switchWorkspace = (id) => {
    localStorage.setItem("fb_workspace_id", id);
    setWorkspaceId(id);
  };

  const activeWorkspace = workspaces.find((w) => w.id === workspaceId) || workspaces[0] || null;

  return (
    <Ctx.Provider value={{
      user, workspaces, workspaceId, activeWorkspace, ready,
      signIn, signUp, signOut, switchWorkspace, refreshMe, establishSession,
    }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
